module.exports = __webpack_public_path__ + "img/look_more_mind.4bc273e5.svg";